"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceInfoResponseMapper = void 0;
var PriceInfoResponseMapper = /** @class */ (function () {
    function PriceInfoResponseMapper(data) {
        this.localData = data;
    }
    PriceInfoResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return PriceInfoResponseMapper;
}());
exports.PriceInfoResponseMapper = PriceInfoResponseMapper;
//# sourceMappingURL=PriceInfoResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/PriceInfoResponseMapper.js
// module id = 1966
// module chunks = 8